<birdz-card [isLoading]="isLoading > 0" [isEmpty]="hasPerimeter !== true || kpis.length === 0">
  <div card-title>
    {{ 'TAB_KPI_DETAILS' | transloco }}
  </div>
  <div card-corner>
    @if (hasPerimeter === true && kpis.length > 0) {
      <button
        class="corner-help-button bdz-mat-icon-button-info"
        matIconButton
        [matTooltip]="'CONTRACT_CONFIG_HELP.TITLE' | transloco"
        (click)="openContractKpiHelp()"
      >
        <mat-icon>question_mark</mat-icon>
      </button>
    }
  </div>
  <div card-empty>
    @if (hasPerimeter === true && kpis.length === 0) {
      {{ 'MISSING_KPI_CONFIG_FOR_CONTRACT_PART_1' | transloco }}<br />
      {{ 'MISSING_KPI_CONFIG_FOR_CONTRACT_PART_2' | transloco }}
    } @else {
      {{ 'PLEASE_SELECT_A_CONTRACT' | transloco }}
    }
  </div>
  <div card-subtitle>
    <div class="section-subtitle">
      <birdz-period-display></birdz-period-display>
    </div>
  </div>
  <div card-body>
    <div class="controls-and-actions">
      <div class="controls">
        <!-- date -->
        <birdz-period-prev-next>
          <birdz-period-picker
            [granularities]="granularities"
            [disabledGranularities]="disabledGranularities"
            [shortcuts]="shortcuts"
            [disabledShortcuts]="disabledShortcuts"
          ></birdz-period-picker>
        </birdz-period-prev-next>

        <!-- kpis -->
        <mat-form-field>
          <mat-label>{{ 'KPIS' | transloco }}</mat-label>
          <mat-select
            #kpiSelect
            multiple="true"
            [(ngModel)]="selectedKpis"
            (ngModelChange)="onKpiSelectionChanged()"
            [required]="true"
          >
            <!-- search bar -->
            <birdz-select-search-bar [options]="kpis" [searchFunction]="kpiSearchFunction" #kpiSearch>
            </birdz-select-search-bar>

            @for (kpi of kpis | filter: kpiSearch.filter; track kpi) {
              <mat-option
                [value]="kpi.id"
                (onSelectionChange)="kpiSearch.onMultipleSelectSelectionChange($event, kpiSelect)"
                [class]="{ 'birdz-admin': kpi.admin_birdz_display }"
              >
                {{ kpi.label }}
              </mat-option>
            }
          </mat-select>

          @if (selectedKpis.length === 0) {
            <mat-error>{{ 'PLEASE_SELECT_AT_LEAST_ONE_KPI' | transloco }}</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="actions"></div>
    </div>

    @if (undisplayableSelectedKpisMessage) {
      <birdz-alert type="warning" icon="warning">
        {{ undisplayableSelectedKpisMessage }}
      </birdz-alert>
    }

    @if (noneOfSelectedKpisAreDisplayableDisclaimer) {
      <birdz-alert type="error" icon="error">
        {{ noneOfSelectedKpisAreDisplayableDisclaimer }}
      </birdz-alert>
    }

    <div class="table-wrapper" [class]="{ hidden: !showTable }">
      <birdz-table-toolbox
        [favorites]="favorites"
        [favoriteHandler]="{ create: saveFavoriteFn, update: updateFavoriteFn, delete: deleteFavoriteFn }"
        (columnsChanged)="onColumnsChanged($event)"
        [gridApi]="gridApi"
      >
        <button
          matIconButton
          (click)="export()"
          [matTooltip]="'EXPORT_TABLE_CONTENT' | transloco"
          [disabled]="isExporting > 0 || !gridApi?.getDisplayedRowCount()"
        >
          @if (isExporting > 0) {
            <div class="loader">
              <mat-spinner diameter="20"></mat-spinner>
            </div>
          } @else {
            <mat-icon>download_2</mat-icon>
          }
        </button>
      </birdz-table-toolbox>
      <ag-grid-angular
        [gridOptions]="gridOptions"
        (gridReady)="onGridReady($event)"
        (cellClicked)="onCellClicked($event)"
        [loading]="isLoading > 0"
      />
    </div>
  </div>
</birdz-card>
